module.exports = __webpack_public_path__ + "static/media/ic_setting_organiser.f942f918.svg";